import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import consts from "../../constant";

const url = `${consts?.BackendUrl}`;

export const createPaymentMethod = createAsyncThunk(
    "p2p/createpaymentmethod", // ✅ Unique action type under
    async (payload, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/p2p/addpaymentmethod`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });

            if (!response?.data?.success) {
                return rejectWithValue(response?.data || "Failed To Add Payment Method");
            }

            return response?.data;
        } catch (error) {
            console.log("erorr",error);
            
            return rejectWithValue(error.response?.data || "Failed To Add Payment Method");
        }
    }
);

// get user payment methods
export const getPaymentMethod = createAsyncThunk(
    "p2p/getpaymentmethod", // ✅ Unique action type under
    async (_, { rejectWithValue }) => {

        try {
            const response = await axios.get(`${url}/p2p/getpaymentmethod`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed To Get Payment Method");
        }
    }
);

// edit user payment methods
export const editPaymentMethod = createAsyncThunk(
    "p2p/editpaymentmethod", // ✅ Unique action type under
    async (payload, { rejectWithValue }) => {

        try {
            const response = await axios.post(`${url}/p2p/updatepaymentmethod`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed To Edit Payment Method");
        }
    }
);



// get order p2p detail 
export const getP2pOrder = createAsyncThunk(
    "p2p/getp2porder", // ✅ Unique action type under
    async (payload: any, { rejectWithValue }) => {

        try {
            const response = await axios.post(`${url}/p2p/getp2porder`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed To Edit Payment Method");
        }
    }
);


//getP2p chats history
export const getP2pChats = createAsyncThunk(
    "p2p/getchats", // ✅ Unique action type under
    async (payload: any, { rejectWithValue }) => {

        try {
            const response = await axios.post(`${url}/p2p/getchats`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed To Edit Payment Method");
        }
    }
);

//Post Notify seller
export const postnotifySeller = createAsyncThunk(
    "p2p/notifyp2p", // ✅ Unique action type under
    async (payload: any, { rejectWithValue }) => {

        try {
            const response = await axios.post(`${url}/p2p/notifyp2p`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed To Edit Payment Method");
        }
    }
);


//Release User Asset 
export const postReleaseAsset = createAsyncThunk(
    "p2p/release", // ✅ Unique action type under
    async (payload: any, { rejectWithValue }) => {

        try {
            const response = await axios.post(`${url}/p2p/release`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed To Edit Payment Method");
        }
    }
);


// delete user payment methods
export const deletePaymentMethod = createAsyncThunk(
    "p2p/deletePaymentMethod", // ✅ Unique action type under
    async (payload: any, { rejectWithValue }) => {

        try {
            const response = await axios.post(`${url}/p2p/removepaymentmethod`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Failed To Edit Payment Method");
        }
    }
);


//get all p2p currencies
export const getP2passetList = createAsyncThunk(
    "p2p/getP2passetList", // ✅ Unique action type under
    async (_, { rejectWithValue }) => {

        try {
            const response = await axios.get(`${url}/p2p/getp2passets`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed To Get Payment Method");
        }
    }
);


//Post payment method
export const createp2p = createAsyncThunk(
    "p2p/createp2p", // ✅ Unique action type under
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/p2p/createp2p`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Failed To Edit Payment Method");
        }
    }
);


//Post User P2p list
export const getUserP2pHistory = createAsyncThunk(
    "p2p/p2phistory", // ✅ Unique action type under
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/p2p/p2phistory`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Failed To Edit Payment Method");
        }
    }
);



//processingP2p 
export const getProcessingP2p = createAsyncThunk(
    "p2p/processp2p", // ✅ Unique action type under
    async (_, { rejectWithValue }) => {

        try {
            const response = await axios.get(`${url}/p2p/processp2p`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed To Get Payment Method");
        }
    }
);

//Open Cancel P2P
export const cancelOpenP2P = createAsyncThunk(
    "p2p/cancelopenp2p",
    async (id: string, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/p2p/cancelopenp2p`, { txId: id }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed To Cancel P2P Order");
        }
    }
);

//Post get all p2p list
export const getbuyAllP2p = createAsyncThunk(
    "p2p/getbuyp2p", // ✅ Unique action type under
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/p2p/getp2p`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Failed To Edit Payment Method");
        }
    }
);


export const getsellAllP2p = createAsyncThunk(
    "p2p/getsellp2p", // ✅ Unique action type under
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/p2p/getp2p`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Failed To Edit Payment Method");
        }
    }
);


//buy or sell p2p
export const moveEscrowp2p = createAsyncThunk(
    "p2p/moveescrow", // ✅ Unique action type under
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/p2p/moveescrow`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Failed To process Method");
        }
    }
);



//Admin Message Raise dispute
export const postRaiseDispute = createAsyncThunk(
    "p2p/raisedispute", // ✅ Unique action type under
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/p2p/raisedispute`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Failed To process Method");
        }
    }
);


//Post message Chat
export const postMessageChat = createAsyncThunk(
    "p2p/updatechat", // ✅ Unique action type under
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/p2p/updatechat`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Failed To process Method");
        }
    }
);

//cancel p2p order
//Admin Message Raise dispute
export const postcancelP2p = createAsyncThunk(
    "p2p/cancelp2p", // ✅ Unique action type under
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/p2p/cancelp2p`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Failed To process Method");
        }
    }
);


const p2pSlice = createSlice({
    name: "p2p",
    initialState: {
        p2p: [],
        p2plist: [],
        userp2plist: [],
        buyallp2plist: [],
        sellallp2plist: [],
        isLoading: false,
        error: null,
        p2pOrder: null,
        notifySeller: null,
        currentP2pTab: "myads",
    },
    reducers: {
        setCurrentP2pTab: (state, action) => {
         state.currentP2pTab = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            // create payment method
            .addCase(createPaymentMethod?.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createPaymentMethod.fulfilled, (state, action) => {
                state.isLoading = false;
            })
            .addCase(createPaymentMethod.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action?.payload;
            })

            // get payment method
            .addCase(getPaymentMethod?.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPaymentMethod.fulfilled, (state, action) => {
                state.isLoading = false;
                state.p2p = action?.payload
            })
            .addCase(getPaymentMethod.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action?.payload;
            })

            // edit payment method
            .addCase(editPaymentMethod?.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(editPaymentMethod.fulfilled, (state, action) => {
                state.isLoading = false;
                state.p2p = action?.payload
            })
            .addCase(editPaymentMethod.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action?.payload;
            })

            // delete payment method
            .addCase(deletePaymentMethod?.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deletePaymentMethod.fulfilled, (state, action) => {
                state.isLoading = false;
                state.p2p = action?.payload
            })
            .addCase(deletePaymentMethod.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action?.payload;
            })

            .addCase(getP2passetList?.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getP2passetList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.p2plist = action?.payload
            })
            .addCase(getP2passetList.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action?.payload;
            })

            //User p2p list
            .addCase(getUserP2pHistory?.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getUserP2pHistory.fulfilled, (state, action) => {
                state.isLoading = false;
                state.userp2plist = action?.payload
            })
            .addCase(getUserP2pHistory.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action?.payload;
            })

            //Get buy all p2p  
            .addCase(getbuyAllP2p?.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getbuyAllP2p.fulfilled, (state, action) => {
                state.isLoading = false;
                state.buyallp2plist = action?.payload
            })
            .addCase(getbuyAllP2p.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action?.payload;
            })

            // get sell all p2p
            .addCase(getsellAllP2p?.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getsellAllP2p.fulfilled, (state, action) => {
                state.isLoading = false;
                state.sellallp2plist = action?.payload
            })
            .addCase(getsellAllP2p.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action?.payload;
            })

            //  get P2p Order List 

            .addCase(getP2pOrder?.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getP2pOrder.fulfilled, (state, action) => {
                state.isLoading = false;
                state.p2pOrder = action?.payload
            })
            .addCase(getP2pOrder.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action?.payload;
            })

            // postnotifySeller
            .addCase(postnotifySeller?.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(postnotifySeller.fulfilled, (state, action) => {
                state.isLoading = false;
                state.notifySeller = action?.payload
            })
            .addCase(postnotifySeller.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action?.payload;
            })
    },
});




export const { setCurrentP2pTab } = p2pSlice.actions;
export default p2pSlice.reducer;
